import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "inputType",
    "switchButton"];

  selectCriteria(event) {
    event.currentTarget.classList.toggle("selected")
    event.currentTarget.querySelector(".cross-criteria").classList.toggle("display-inline")
    if(this.inputTypeTarget.value.includes(event.currentTarget.dataset.text)) {
      this.inputTypeTarget.value = this.inputTypeTarget.value.replace(`${event.currentTarget.dataset.text},`, "")
    } else {
      this.inputTypeTarget.value += event.currentTarget.dataset.text + ","
    }
    this.refreshHelps();
  }

  refreshHelps() {
    fetch(`${this.formTarget.action}?&type_list=${this.inputTypeTarget.value}&open=${this.switchButtonTarget.checked}`, { headers: { 'Accept': 'text/plain' } })
    .then(response => response.text())
    .then((data) => {
      document.querySelector("#main-index-helps").outerHTML = data;
    })
    window.scrollTo(0, 0);
  }

}
